import { SPACING_40, SpacingVertical, Wizard } from 'mailup-web-components'
import WorkflowWizardFifthStep from 'Pages/Workflow/components/WorkflowWizardFifthStep'
import WorkflowWizardFirstStep from 'Pages/Workflow/components/WorkflowWizardFirstStep'
import WorkflowWizardFourthStep from 'Pages/Workflow/components/WorkflowWizardFourthStep'
import WorkflowWizardSecondStep from 'Pages/Workflow/components/WorkflowWizardSecondStep'
import WorkflowWizardThirdStep from 'Pages/Workflow/components/WorkflowWizardThirdStep'
import {
  changeWizardStepCallback,
  disableAndEditConfirmCallback,
  editCallback,
  loadWizardStepDataCallback
} from 'Pages/Workflow/recoil/callbacks/callbacks'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import {
  wizardEnableStep1State,
  wizardEnableStep2State,
  wizardEnableStep3State,
  wizardEnableStep4State,
  wizardEnableStep5State,
  wizardSteps
} from 'Pages/Workflow/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'

// import { Wizard, Loading } from 'mailup-web-components'

import { modalEditDisableState } from '../recoil/state/modals'
import ModalDisableEditWorkflow from './Modals/ModalDisableEditWorkflow'

const WizardContainer = () => {
  const intl = useIntl()
  const { Id } = useRecoilValue(workflowDetails)
  const { wizardStep } = useRecoilValue(wizardSteps)
  const enableStep1 = useRecoilValue(wizardEnableStep1State)
  const enableStep2 = useRecoilValue(wizardEnableStep2State)
  const enableStep3 = useRecoilValue(wizardEnableStep3State)
  const enableStep4 = useRecoilValue(wizardEnableStep4State)
  const enableStep5 = useRecoilValue(wizardEnableStep5State)

  // const { showLoading } = useRecoilValue(sendingPreviewState)

  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])
  const loadWizardStepData = useRecoilCallback(loadWizardStepDataCallback, [])

  const { show } = useRecoilValue(modalEditDisableState)
  const disableAndEditConfirm = useRecoilCallback(disableAndEditConfirmCallback)
  const disableAndEditCancel = useResetRecoilState(modalEditDisableState)
  const edit = useRecoilCallback(editCallback, [])

  useEffect(() => {
    loadWizardStepData()
  }, [wizardStep, Id])

  const options = [
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.TitleStepNavigation1'
      }),
      value: 1,
      enabled: enableStep1
    },
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.TitleStepNavigation2'
      }),
      value: 2,
      enabled: enableStep2
    },
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.TitleStepNavigation3'
      }),
      value: 3,
      enabled: enableStep3
    },
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.TitleStepNavigation4'
      }),
      value: 4,
      enabled: enableStep4
    },
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.TitleStepNavigation5'
      }),
      value: 5,
      enabled: enableStep5
    }
  ]

  const handleChangeWizard = (step) => {
    if (wizardStep === 5) {
      edit(step)
    } else {
      changeWizardStep(step)
    }
  }

  return (
    <>
      <ModalDisableEditWorkflow
        show={show}
        onCancel={disableAndEditCancel}
        onConfirm={disableAndEditConfirm}
      />
      <Wizard
        value={wizardStep}
        options={options}
        onChange={handleChangeWizard}
      />
      <SpacingVertical variant={SPACING_40} />
      {wizardStep === 1 && <WorkflowWizardFirstStep />}
      {wizardStep === 2 && <WorkflowWizardSecondStep />}
      {wizardStep === 3 && <WorkflowWizardThirdStep />}
      {wizardStep === 4 && <WorkflowWizardFourthStep />}
      {wizardStep === 5 && <WorkflowWizardFifthStep />}
    </>
  )
}

export default WizardContainer
